import React from 'react';
import { Calendar, ZoomIn, ZoomOut } from 'lucide-react';

const TimeRangeSelector = ({ value, onChange }) => {
  const ranges = [
    { label: '7 Days', value: 7 },
    { label: '14 Days', value: 14 },
    { label: '30 Days', value: 30 },
    { label: '60 Days', value: 60 },
    { label: '90 Days', value: 90 }
  ];

  return (
    <div className="time-range-selector">
      <div className="time-range-label">
        <Calendar size={16} />
        <span>Time Range:</span>
      </div>
      
      <div className="time-range-buttons">
        {ranges.map((range) => (
          <button
            key={range.value}
            onClick={() => onChange(range.value)}
            className={`time-range-btn ${value === range.value ? 'active' : ''}`}
          >
            {range.label}
          </button>
        ))}
      </div>
      
      <div className="zoom-controls">
        <button 
          onClick={() => onChange(Math.max(7, value - 7))}
          className="zoom-btn"
          title="Zoom in (shorter period)"
          disabled={value <= 7}
        >
          <ZoomIn size={16} />
        </button>
        <button 
          onClick={() => onChange(Math.min(90, value + 7))}
          className="zoom-btn"
          title="Zoom out (longer period)"
          disabled={value >= 90}
        >
          <ZoomOut size={16} />
        </button>
      </div>
    </div>
  );
};

export default TimeRangeSelector;
